export enum TipoVisibilitaEnum {
    SOLA_LETTURA = <any>"SOLA_LETTURA",
    MODIFICA = <any>"MODIFICA",
    SOLA_LETTURA_SOTTOFASCICOLI = <any>"SOLA_LETTURA_SOTTOFASCICOLI",
    MODIFICA_SOTTOFASCICOLI = <any>"MODIFICA_SOTTOFASCICOLI",
    NESSUNA = <any>"NESSUNA",
    PROPRIETARIO = <any>"PROPRIETARIO"
}
